import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Body1, HeaderBlock, Button, Separator } from '@fs/zion-ui'
import { Title } from '@fs/zion-head'
import PersonPageBanner from '@fs/tree-person-page-banner'
import PersonNotFound from './PersonNotFound.svg'

const imageCss = css`
  background-image: url(${PersonNotFound});
  background-color: #c4c4c4;
  background-position: center bottom;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100vh;
`

const person = {
  name: undefined,
  gender: 'UNKNOWN',
}

const contentCss = css`
  margin-top: 50px;
  text-align: center;

  & img {
    max-width: 390px;
  }
`

export default function ServerError(): JSX.Element {
  const [t] = useTranslation()

  return (
    <div css={imageCss}>
      <Title>{`${t('ancestors.error-page.meta-data.title')} | ${t('ancestors.server-error.header')}`}</Title>
      <PersonPageBanner person={person} notFound />
      <div data-testid="server-error" css={contentCss}>
        <HeaderBlock heading={t('ancestors.server-error.header')} size="md" />
        <Body1>{t('ancestors.server-error.text')}</Body1>
        <Separator size="md" />
        <Button
          data-testid="server-error-button"
          emphasis="medium"
          onClick={() => {
            window?.location.reload()
          }}
        >
          {t('ancestors.reload-page.action')}
        </Button>
      </div>
    </div>
  )
}
